<div class="vertical-line"></div>



<div class=" reservation_step">
  <ul>
    <li routerLinkActive="active" class="left-link">

      <span>1.</span> Personal
    </li>
    <li routerLinkActive=" active" class="active">

      <span>2.</span> Conference
    </li>
    <li routerLinkActive="active">

      <span>3.</span> Accommodation
    </li>
    <li routerLinkActive="active ">

      <span>4.</span> Room Choice
    </li>
    <li routerLinkActive="active">

      <span>5.</span> Tour
    </li>
    <li routerLinkActive="active" class="right-link">

      <span>6.</span> Confirm
    </li>
  </ul>
</div>
<div class="info">
  <form class="row" [formGroup]="conferenceinfoForm" class="personalinfo" (submit)="submitConferenceInfo()">
    <div class="form-group">


      <div class="row">
        <label>Name Of Church</label>
        <input kendoTextBox style="width: 500px;" formControlName="nameOfChurch">
      </div>

      <div class="row">
        <label>Group A (Select one Track):
          <small style="color:red">*</small>
        </label>
        <span *ngIf="conferenceinfoForm.get('groupASession').touched && conferenceinfoForm.get('groupASession').invalid">
          <small style="color:red">You must choose ONE track.</small>
        </span>
        <kendo-dropdownlist [data]="groupAList" style="width: 500px;" formControlName="groupASession">
        </kendo-dropdownlist>
      </div>

      <div class="row">
        <label>Group B (Select one Track):
          <small style="color:red">*</small>
        </label>
        <span *ngIf="conferenceinfoForm.get('groupBSession').touched && conferenceinfoForm.get('groupBSession').invalid">
          <small style="color:red">You must choose ONE track.</small>
        </span>
        <kendo-dropdownlist [data]="groupBList" style="width: 500px;" formControlName="groupBSession">
        </kendo-dropdownlist>
      </div>

      <div class="row">
        <span>
          <label for="ngyn">Include Empowered21 NGYN Conference? (IN / OUT) - R60 ($5.50):</label>
          <kendo-switch [onLabel]="'YES'" [offLabel]="'NO'" formControlName="includeNgyn"></kendo-switch>
        </span>
      </div>

      <div class="row">
        <!-- <label>Will you be interested in business & investment opportunity links?:</label>
        <kendo-dropdownlist [data]="includeInBusinessDecision" style="width: 500px;" formControlName="includeInBusiness">
        </kendo-dropdownlist> -->

        <span>
          <label for="inBusiness">Will you be interested in business & investment opportunity links?:</label>
          <kendo-switch [onLabel]="'YES'" [offLabel]="'NO'" formControlName="includeInBusiness"></kendo-switch>
        </span>
      </div>

      <div class="row">
        <label>If yes, please specify your profession, occupation or area of expertise:</label>
        <input class="col-sm-8" kendoTextBox style="width: 500px;" formControlName="expertise">
      </div>

      <div class="buts" style="width: 500px;">
        <button class="btn btn-success" type="submit" (click)="cancel()">Cancel</button>
        <button class="btn btn-primary" type="submit" (click)="jumpToTour()">No Accommodation</button>
        <button class="btn btn-info" [disabled]="conferenceinfoForm.invalid" type="submit">Continue</button>
      </div>
    </div>
  </form>
</div>


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/form-components/conferenceinfo/conferenceinfo.component.html